<script>
import MyID from './MyID.svelte';
import { onMount } from 'svelte';
onMount(() => {
	fetch('anim/fail.json');
	fetch('anim/success.json');
	fetch('anim/circle.json');
})
</script>

<div class="myid-host">
<MyID />
</div>

<style>
:global(body) {
	padding: 0;
}
.myid-host {
	display: flex;
	justify-content: center;
	align-items: stretch;
	min-height: 100%;
}
</style>